import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import 'rxjs/add/observable/of';
import {UserService} from '../../services/user.service';
import {User} from '../../model/Entities/User';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {UsersDataSource} from '../../model/DataSources/UsersDataSource';
import {SnackService} from '../../services/snack.service';
import {DialogService} from '../../services/dialog.service';
import {UserDeleteConfirmDialogComponent} from '../UserDeleteConfirmDialogComponent/user-delete-confirm.dialog.component';
import {Router} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {Filter} from '../../model/Helpers/Filter';
import {Pagination} from '../../model/Helpers/Pagination';
import {RoleService} from '../../services/role.service';
import {Customer} from '../../model/Entities/Customer';
import {UserRole} from '../../model/Entities/UserRole';

@Component({
    selector: 'users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss']
})

export class UsersListComponent extends BaseListComponent implements AfterViewInit {
    tableColumns: String[] = ['name', 'email', 'active', 'role', 'actions'];

    defaultFilters = {
        active: 'all',
        role_id: 'all'
    };

    roles = [] as UserRole[];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('search') search: ElementRef;

    constructor(private userService: UserService,
                private snackService: SnackService,
                private roleService: RoleService,
                private dialogService: DialogService,
                private router: Router) {
        super();

        this.dataSource = new UsersDataSource(this.userService);

        this.roleService.getSimpleList([
        ]).subscribe((data: UserRole[]) => {
            this.roles = data;
        });

    }

    ngAfterViewInit() {
        this.resetFilters();
        this.prepareDataLoading();
        this.reloadPage();

        // If the user changes the sort order, reset back to the first page.
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }

    prepareDataLoading(): void {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged(),
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }

            const f = [];
            if (this.search.nativeElement.value.trim().length > 0) {
                f.push(new Filter('search', this.search.nativeElement.value.trim()));
            }
            if (this.filters.active !== 'all') {
                f.push(new Filter('active', this.filters.active));
            }
            if (this.filters.role_id !== 'all') {
                f.push(new Filter('role_id', this.filters.role_id));
            }

                this.dataSource.loadPage(
                    new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                    new SortInfo(this.sort.active, this.sort.direction), f,
                    {expand: 'role'});
            }
        );
    }
    public resetFilters(): void {
        if (this.search) {
            this.search.nativeElement.value = '';
        }
        super.resetFilters();
    }

    showUserDetail(user: User): void {
        this.router.navigate([`/user/${user.id}`]);
    }

    deactivate(user: User): void {
        this.userService.deactivate(user).subscribe(() => {
            this.snackService.showSuccess(`Účet uživatele ${user.name} ${user.surname} byl zakázán`);
        });
    }

    activate(user: User): void {
        this.userService.activate(user).subscribe(() => {
            this.snackService.showSuccess(`Účet uživatele ${user.name} ${user.surname} byl povolen`);
        });
    }

    delete(user: User): void {
        this.dialogService.showDialog(UserDeleteConfirmDialogComponent, {
            'user': user
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.userService.delete(user.id).subscribe(() => {
                    this.snackService.showSuccess(`Účet uživatele ${user.name} ${user.surname} byl smazán`);
                    this.reloadPage();
                });
            }
        });
    }

}




// WEBPACK FOOTER //
// /app/src/UsersModule/UsersListComponent/users-list.component.ts